export const statusList = [
  {
    id: 1,
    label: "health_states.healthy",
    status: 0,
    key: 0,
    value: "health_states.healthy",
    todo: "health_states.healthy_todo",
  },
  {
    id: 2,
    label: "health_states.drying_out",
    status: 1,
    key: 1,
    value: "health_states.drying_out",
    todo: "health_states.drying_out_todo",
  },
  {
    id: 3,
    label: "health_states.dry",
    status: 2,
    key: 2,
    value: "health_states.dry",
    todo: "health_states.dry_todo",
  },
  {
    id: 4,
    label: "health_states.unknown",
    status: 3,
    key: 3,
    value: "health_states.unknown",
    todo: "health_states.unknown_todo",
  },
  {
    id: 5,
    label: "health_states.frost",
    status: 4,
    key: 4,
    value: "health_states.frost",
    todo: "health_states.frost_todo",
  },
  {
    id: 6,
    label: "health_states.too_wet",
    status: 5,
    key: 5,
    value: "health_states.too_wet",
    todo: "health_states.too_wet_todo",
  },
];
